import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="popup"
export default class extends Controller {
  static values = {
    active: { type: Boolean, default: false },
    hideAnchor: { type: Boolean, default: false },
  };

  toggle() {
    this.activeValue = !this.activeValue;
  }

  activeValueChanged() {
    if (this.activeValue) {
      this.element.setAttribute("active", "");

      if (this.hideAnchorValue)
        this.anchorElement.classList.add("wa-visually-hidden-force");
    } else {
      this.element.removeAttribute("active");

      if (this.hideAnchorValue)
        this.anchorElement.classList.remove("wa-visually-hidden-force");
    }
  }

  get anchorElement() {
    return this.element.querySelector("[slot='anchor']");
  }
}
